import styled from 'styled-components';
import {dFlexEnd} from '../../../../../globalVariables/GlobalFlex';

export const primaryBtnWrap = styled.div`
    ${dFlexEnd};
    width: 100%;

    #classicButton {
        border-radius: 100px;
        padding: var(--space-sm) var(--space-lg);
        background: var(--color-brand-main);
        font-weight: var(--font-weight-bold);
        font-size: var(--font-size-body-small);
        color: var(--color-text-default);
    }
`;
